import { round } from 'lodash-es';
import { UnitSystem } from '../constants';
import { conversionTables } from '../conversionTables';
const getValue = (value, unitId, systemTo, precision = 0) => {
    if (!value)
        return value;
    const conversionFactor = systemTo === UnitSystem.METRIC
        ? 1
        : conversionTables[systemTo].conversionFactors?.[unitId].general;
    return round(value * conversionFactor, precision);
};
export default getValue;
//# sourceMappingURL=getValue.js.map